import { Component, Element, Host, Prop, h } from '@stencil/core';
import { endpoints } from '../../../.conf/resources';
import { calculateEnergyEfficiencyImagePath } from '../../helpers/helpers';
import {
  type CssClassMap,
  type EnergyEfficiencyScale,
  EnergyEfficiencyVersion,
} from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-energy-label',
  styleUrl: 'cms-energy-label.scss',
  shadow: true,
})
export class CmsEnergyLabel {
  private modalComponent: HTMLCmsModalElement;
  private readonly letterSvgPathObj = {
    A: (
      <path
        d='M26.38 18.48c.28 0 .5 0 .67-.02.17-.02.28-.06.34-.12.07-.06.1-.15.08-.27s-.07-.3-.14-.5L23.82 7.47a.85.85 0 0 0-.13-.26c-.05-.06-.13-.11-.25-.15s-.27-.05-.47-.06L22.14 7h-.17l-.55.01c-.18.01-.33.03-.43.06-.1.04-.18.08-.22.15s-.09.14-.13.24l-3.5 10.09c-.07.2-.12.37-.13.49-.02.12 0 .22.06.28s.16.11.31.13a5.85 5.85 0 0 0 1.25.01c.15-.01.27-.03.36-.06.08-.04.14-.08.18-.14s.07-.12.1-.2l.72-2.23h4.27l.76 2.29a.6.6 0 0 0 .09.18c.03.05.1.09.18.11.1.03.22.05.39.06h.7zm-2.66-4.42H20.5l1.6-4.84h.01z'
        fill='#fff'
      />
    ),
    B: (
      <path
        d='M21.7 18.37c.47 0 .88-.02 1.25-.08s.72-.14 1.05-.26.63-.27.9-.45a2.98 2.98 0 0 0 1.34-2.62 2.7 2.7 0 0 0-.65-1.86c-.21-.23-.45-.42-.72-.56a3 3 0 0 0-.9-.31 2.52 2.52 0 0 0 1.18-.9c.13-.2.23-.42.3-.66.07-.24.1-.5.1-.78 0-.5-.08-.92-.26-1.28-.17-.36-.42-.67-.76-.9s-.73-.42-1.22-.53A7.64 7.64 0 0 0 21.54 7H18.7c-.2 0-.36.06-.5.17-.12.12-.19.3-.19.56v9.91c0 .26.07.45.2.56.13.12.3.17.49.17zm-.14-6.69h-1.3V8.73h1.18c.35 0 .64.03.85.1s.4.15.54.27.24.28.31.46.1.38.1.61c0 .2-.03.4-.09.59a1.32 1.32 0 0 1-.8.8c-.19.09-.46.12-.79.12zm.38 4.93h-1.67v-3.24h1.37c.42 0 .76.04 1.03.12s.48.18.65.32.3.32.38.52a1.8 1.8 0 0 1 0 1.38c-.1.2-.22.36-.38.5-.16.13-.35.23-.57.3-.22.06-.49.1-.81.1z'
        fill='#fff'
      />
    ),
    C: (
      <path
        d='M22.27 18.74a6.02 6.02 0 0 0 2.7-.64c.19-.1.31-.2.38-.26a.92.92 0 0 0 .14-.18.75.75 0 0 0 .07-.19l.04-.26a4.47 4.47 0 0 0-.06-1.17c-.02-.08-.05-.12-.09-.15a.25.25 0 0 0-.14-.03c-.07 0-.18.05-.32.14l-.53.32c-.21.11-.47.22-.76.32s-.66.14-1.07.14c-.45 0-.86-.08-1.22-.23-.36-.16-.66-.4-.92-.7-.25-.32-.45-.73-.59-1.22s-.2-1.06-.2-1.73c0-.61.06-1.16.19-1.65.13-.48.32-.9.57-1.24.25-.34.55-.6.9-.8s.76-.27 1.21-.27a3.25 3.25 0 0 1 1.82.5c.22.12.4.24.53.34s.24.16.33.16c.05 0 .1-.02.14-.06.04-.03.08-.09.1-.16.04-.08.06-.18.07-.3a4.83 4.83 0 0 0-.04-1.15.74.74 0 0 0-.07-.2.99.99 0 0 0-.16-.2 4.07 4.07 0 0 0-1.09-.58 5.58 5.58 0 0 0-3.87.1c-.64.27-1.2.66-1.66 1.17-.47.5-.83 1.14-1.08 1.89s-.39 1.6-.39 2.57c0 .95.12 1.78.35 2.5.24.71.57 1.3 1.01 1.79.44.47.97.83 1.6 1.07.63.24 1.33.36 2.11.36z'
        fill='#fff'
      />
    ),
    D: (
      <path
        d='M20.85 18.37c1 0 1.88-.1 2.6-.33a4.7 4.7 0 0 0 1.87-1.03c.5-.47.9-1.07 1.17-1.81.27-.75.4-1.64.4-2.68 0-.9-.12-1.7-.37-2.38a4.52 4.52 0 0 0-2.89-2.78A8.16 8.16 0 0 0 21.05 7h-2.91c-.2 0-.36.06-.5.17-.12.12-.19.3-.19.56v9.91c0 .26.07.45.2.56.13.12.3.17.49.17zm.1-1.83h-1.2V8.81h1.17c.71 0 1.28.1 1.72.29.44.19.8.45 1.07.8s.48.73.6 1.2a6.18 6.18 0 0 1-.03 3.23c-.13.48-.35.9-.64 1.23-.29.33-.65.57-1.08.74-.44.16-.97.24-1.6.24z'
        fill='#fff'
      />
    ),
    E: (
      <path
        d='M24.9 18.37c.05 0 .1-.01.14-.05.05-.03.08-.08.11-.15s.05-.16.07-.28a3.44 3.44 0 0 0-.07-1.13.35.35 0 0 0-.1-.15.24.24 0 0 0-.15-.05h-4.1v-3.2h3.44c.05 0 .1-.02.14-.05a.32.32 0 0 0 .11-.14c.03-.07.06-.16.07-.27a3.33 3.33 0 0 0-.07-1.11.36.36 0 0 0-.1-.15.24.24 0 0 0-.15-.05H20.8V8.8h4.06c.06 0 .1-.02.14-.05.04-.03.08-.08.1-.15s.06-.16.08-.28a3.36 3.36 0 0 0-.07-1.13.34.34 0 0 0-.1-.16.24.24 0 0 0-.15-.04H19.2c-.2 0-.36.06-.5.17-.12.12-.19.3-.19.56v9.91c0 .26.07.45.2.56.13.12.3.17.49.17z'
        fill='#fff'
      />
    ),
    F: (
      <path
        d='M20.16 18.43a4.89 4.89 0 0 0 .92-.1.4.4 0 0 0 .19-.12c.03-.05.05-.1.05-.17V13.8h3.49c.05 0 .1-.01.14-.05.04-.03.08-.08.11-.16s.06-.17.07-.29l.02-.44c0-.17 0-.32-.02-.44s-.04-.2-.07-.28-.07-.12-.11-.15-.09-.04-.14-.04h-3.49V8.89h3.72c.05 0 .1-.02.14-.05a.45.45 0 0 0 .1-.16.99.99 0 0 0 .08-.29 3.76 3.76 0 0 0-.07-1.18.4.4 0 0 0-.11-.16.22.22 0 0 0-.14-.05h-5.35c-.2 0-.36.06-.5.17-.12.12-.19.3-.19.56v10.3c0 .07.02.13.06.18.04.04.1.08.19.11.08.04.2.06.35.08.15.02.34.03.56.03z'
        fill='#fff'
      />
    ),
    G: (
      <path
        d='M22.8 18.76a9.77 9.77 0 0 0 3.42-.62c.2-.08.32-.18.38-.32.06-.13.1-.28.1-.46v-4.52c0-.12-.02-.23-.05-.32a.66.66 0 0 0-.13-.23.54.54 0 0 0-.44-.2h-3.84c-.05 0-.1.02-.14.06a.38.38 0 0 0-.1.15c-.04.06-.06.15-.07.26a3.25 3.25 0 0 0 .06 1.09c.06.13.14.2.25.2h2.15v2.63c-.22.12-.45.2-.7.27a3.95 3.95 0 0 1-2.21-.17 2.99 2.99 0 0 1-1.12-.76c-.31-.33-.55-.74-.73-1.24s-.26-1.07-.26-1.72c0-.59.09-1.13.26-1.62.17-.49.41-.9.73-1.26.31-.34.7-.61 1.14-.8s.94-.29 1.5-.29a5.22 5.22 0 0 1 2.36.5c.28.12.5.24.68.34.17.1.29.16.36.16.06 0 .1-.01.14-.04a.33.33 0 0 0 .1-.16l.06-.3a3.78 3.78 0 0 0-.03-1.1.73.73 0 0 0-.17-.34 1.89 1.89 0 0 0-.42-.3A7.1 7.1 0 0 0 22.92 7c-.9.01-1.7.15-2.44.42a5.17 5.17 0 0 0-3.06 3.08A7.03 7.03 0 0 0 17 13c0 .9.13 1.71.4 2.42.26.72.64 1.32 1.14 1.81.5.5 1.1.88 1.82 1.14.72.26 1.53.39 2.44.39z'
        fill='#fff'
      />
    ),
  };
  /**
   * Set EnergyVersion to V2 by default
   */
  private version = EnergyEfficiencyVersion.V2;

  @Element() element: HTMLElement;
  /**
   * set Energy Label like A, A++ ...
   */
  @Prop() energyLabel: string;
  /**
   * set Energy Label Image URL show in cms-modal
   */
  @Prop() energyImgUrl: string;
  /**
   * set Energy Version like V1 or V2
   */
  @Prop() energyVersion: string;
  /**
   * set Energy Rank like 1-7
   */
  @Prop() energyRank: string;
  /**
   * set productdatasheet-url - leave empty if no datasheet is available
   */
  @Prop() datasheetUrl?: string;
  /**
   * set label for datasheet-link
   */
  @Prop() datasheetLabel?: string;
  /**
   * set label for datasheet-link
   */
  @Prop() datasheetAccessibleName?: string;
  /**
   * set scale
   */
  @Prop() scale?: string | EnergyEfficiencyScale;
  /**
   * set name for label
   */
  @Prop() name?: string;
  /**
   * set size corresponding to price size
   */
  @Prop() size = 'MD';
  /**
   * set eek label as part of multi eek
   */
  @Prop() multi?: boolean = false;

  private currentScale?: EnergyEfficiencyScale;

  /*
    Lifecycle
  */
  componentWillLoad() {
    this.version =
      this.energyVersion === 'V1'
        ? EnergyEfficiencyVersion.V1
        : EnergyEfficiencyVersion.V2;
    this.currentScale =
      typeof this.scale === 'string' ? JSON.parse(this.scale) : this.scale;
  }

  componentDidLoad() {
    this.modalComponent = document.querySelector('cms-modal');
  }

  /*
    Interaction
  */
  private openModal() {
    if (this.energyImgUrl !== '') {
      this.modalComponent.open = true;
    }
  }

  private async modalContent() {
    if (this.modalComponent && this.energyImgUrl) {
      await this.modalComponent.reset();
      this.modalComponent.setModalContent = ` <img
          alt=${this.energyLabel}
          src=${this.energyImgUrl}
          width='500'
          height='400'
          class='energy-label-img'
        />`;
    }
  }

  /*
    Render methods
  */
  private getDatasheetContent() {
    if (
      this.datasheetUrl !== undefined &&
      this.datasheetUrl !== '' &&
      this.datasheetLabel !== undefined &&
      this.datasheetLabel !== ''
    ) {
      return (
        <cms-link
          type='standalone'
          href={this.datasheetUrl}
          content={this.datasheetLabel}
          size='sm'
          linkTitle={this.datasheetLabel}
          target='_blank'
          nowrap={true}
          accessibleName={this.datasheetAccessibleName}
        />
      );
    }
    return '';
  }

  private renderLabel() {
    if (this.version === EnergyEfficiencyVersion.V2 && !this.currentScale) {
      return this.buildEnergyV2Svg(this.getLetterSvgPath());
    }
    if (this.currentScale) {
      return this.getLetterSvgUrl();
    }
    return <div class='label'>{this.energyLabel}</div>;
  }

  private getLetterSvgPath() {
    return this.letterSvgPathObj[this.energyLabel];
  }

  private buildEnergyV2Svg(letterPath: string) {
    return (
      <svg
        class='svg-eek-template'
        viewBox='0 0 47 26'
        xmlns='http://www.w3.org/2000/svg'
      >
        <title>{this.energyLabel}</title>
        <g fill='none' fill-rule='evenodd'>
          <path
            class='letter-path'
            d='M33.2.5 45.7 13 33.2 25.5H.5V.5z'
            fill='#'
            stroke='#000'
          />
          <g fill-rule='nonzero' fill='none'>
            <path d='M11 1h22v24H11z' />
            {letterPath}
          </g>
          <path d='M1 1h10v24H1z' fill='#fff' />
          <path
            d='M6.56 17a4.1 4.1 0 0 1 1.2.17c.15.05.28.1.38.16.1.06.17.1.2.14.05.05.08.1.1.18l.02.33a1.9 1.9 0 0 1-.04.37.17.17 0 0 1-.05.07.1.1 0 0 1-.07.03c-.04 0-.1-.03-.18-.08a2.74 2.74 0 0 0-.84-.35c-.2-.05-.43-.08-.68-.08-.28 0-.53.05-.75.15-.22.1-.41.23-.57.4a1.8 1.8 0 0 0-.37.63c-.08.24-.12.52-.12.81 0 .33.04.61.13.86s.2.46.36.62.34.3.56.38a1.98 1.98 0 0 0 1.1.08c.13-.03.25-.07.36-.13v-1.32H6.18c-.03-.02-.06-.05-.08-.1a1.62 1.62 0 0 1-.03-.54c0-.05.01-.1.03-.13l.05-.08a.11.11 0 0 1 .07-.02H8.2l.05.02c.04.02.07.04.1.08l.07.11.02.16V22.27a.5.5 0 0 1-.05.14c-.03.07-.1.12-.19.16a3.95 3.95 0 0 1-.79.22 4.77 4.77 0 0 1-.92.09c-.45 0-.86-.07-1.22-.2s-.66-.32-.91-.56-.44-.55-.57-.9c-.13-.36-.2-.77-.2-1.22 0-.46.07-.88.21-1.25a2.58 2.58 0 0 1 1.53-1.54c.37-.14.77-.21 1.22-.21zm-.28-6.91.07.06 1.5 1.5a.5.5 0 0 1-.63.76l-.07-.06-.65-.64V15a.5.5 0 0 1-1 .09V11.7l-.65.65a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07 1.5-1.5a.5.5 0 0 1 .63-.06zM6.2 3a8.38 8.38 0 0 1 .53.04c.06.01.1.04.13.07l.06.13 1.76 5.04.03.1.03.15c.01.06 0 .11-.03.14-.03.03-.1.05-.17.06a4.03 4.03 0 0 1-.88-.02.17.17 0 0 1-.1-.06.3.3 0 0 1-.04-.1l-.38-1.13H4.99l-.36 1.1-.02.06-.02.05a.19.19 0 0 1-.1.07l-.18.03H3.7c-.07-.01-.13-.03-.16-.07-.03-.03-.04-.08-.03-.14l.07-.25 1.75-5.04.03-.07.03-.05a.22.22 0 0 1 .12-.07A6.1 6.1 0 0 1 5.93 3zm-.13 1.11-.81 2.42h1.61z'
            fill='#000'
            fill-rule='nonzero'
          />
        </g>
      </svg>
    );
  }
  private getCssClassMap(): CssClassMap {
    const version = this.currentScale
      ? 'v1'
      : this.energyVersion?.toLowerCase();
    return {
      'energy-label-element': true,
      [`energy-version-${version}`]: this.energyVersion !== undefined,
      'has-label': this.energyImgUrl !== '',
      multi: this.multi,
    };
  }

  private getLetterSvgUrl() {
    return (
      <img
        src={calculateEnergyEfficiencyImagePath(
          endpoints.cdn,
          this.currentScale,
          this.energyLabel,
        )}
        title={this.energyLabel}
        alt={this.energyLabel}
        width='102'
        height='53'
      />
    );
  }
  render() {
    return (
      <Host class={this.size.toLowerCase()}>
        <div class={this.getCssClassMap()}>
          <button
            type='button'
            title={this.energyLabel}
            onClick={() => {
              this.modalContent();
              this.openModal();
            }}
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                this.modalContent();
                this.openModal();
              }
            }}
            class={`energy-rank-${this.energyRank}`}
          >
            {this.renderLabel()}
          </button>
          <div class='datasheet-wrapper'>
            {this.name ? <div class='name-wrapper'>{this.name}</div> : ''}
            <div class='datasheet-link-wrapper'>
              {this.getDatasheetContent()}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
